export default __webpack_public_path__ + "static/media/tim-willstead.1ccb21a8.png";